import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './constants/index'
import Home from './pages/Home'

function App() {
  return (
    <Router>
      <Routes>
        <Route path='/' element={<Home countryCode='EN' />}></Route>
        <Route path='/id' element={<Home countryCode='ID' />}></Route>
      </Routes>
    </Router>
  );
}

export default App;